import { z } from 'zod';
import {
  booleanOperators,
  datetimeOperators,
  picklistOperators,
  stringOperators,
} from './operators';

export const datetimeFilter = z
  .object({
    value: z
      .union([z.string(), z.array(z.string())])
      .nullable()
      .optional(),
    operator: datetimeOperators,
  })
  .optional();

export const picklistFilter = z
  .object({
    value: z
      .union([z.number(), z.array(z.number())])
      .nullable()
      .optional(),
    operator: picklistOperators,
  })
  .optional();

export const booleanFilter = z
  .object({
    value: z.boolean().nullable().optional(),
    operator: booleanOperators,
  })
  .optional();

const textCustomFieldFilter = z.object({
  value: z.string().nullable().optional(),
  operator: stringOperators,
});

const picklistCustomFieldFilter = z.object({
  value: z
    .union([z.number(), z.array(z.number())])
    .nullable()
    .optional(),
  operator: picklistOperators,
});

const userCustomFieldFilter = z.object({
  value: z
    .union([z.string(), z.array(z.string())])
    .nullable()
    .optional(),
  operator: picklistOperators,
});

const dateCustomFieldFilter = z.object({
  value: z
    .union([z.string(), z.array(z.string())])
    .nullable()
    .optional(),
  operator: datetimeOperators,
});

const booleanCustomFieldFilter = z.object({
  value: z
    .union([z.string(), z.array(z.string())])
    .nullable()
    .optional(),
  operator: picklistOperators,
});

const CF_KEY_PATTERN = /^cf\.(\d+)\.(\w+)$/;

const customFieldFilterByType: Record<string, z.ZodType> = {
  text: textCustomFieldFilter,
  link: textCustomFieldFilter,
  picklist: picklistCustomFieldFilter,
  itemId: picklistCustomFieldFilter,
  userId: userCustomFieldFilter,
  checked: booleanCustomFieldFilter,
  date: dateCustomFieldFilter,
};

export const parseCustomFieldSearchParams = (
  search: Record<string, unknown>,
): Record<string, unknown> => {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(search)) {
    const match = key.match(CF_KEY_PATTERN);
    if (!match?.[2]) continue;
    const cfType = match[2];
    const schema = customFieldFilterByType[cfType];
    if (!schema) continue;
    const parsed = schema.safeParse(value);
    if (parsed.success) {
      result[key] = parsed.data;
    }
  }
  return result;
};
